import clsx from 'clsx';
import { Button, Typography } from '@/components/common';
import AppRoutes from '@/const/routes';
import { customEvent } from '@/lib';
import { useRouter } from 'next/router';

interface Props {
	classNameContainer?: string;
	className?: string;
}

export const ReadyToGetBanner: React.FC<Props> = ({
	className,
	classNameContainer,
}) => {
	const router = useRouter();
	return (
		<div className="py-[100px] px-4 lg:px-[88px]">
			<div
				className={clsx(
					'relative bg-grey-5 rounded-[32px] lg:rounded-[64px] border border-grey-100 lg:mx-4 xl:w-full xl:mx-auto overflow-hidden bg-[url(/img/landing/bg-ready-mobile.svg)] lg:bg-[url(/img/landing/bg-ready.svg)] bg-cover bg-no-repeat',
					classNameContainer
				)}
			>
				<div
					className={clsx(
						'space-y-8 px-4 py-10 lg:py-20 z-10 relative',
						'flex flex-col items-center w-full',
						className
					)}
				>
					<Typography
						type="headline-2"
						className="text-white font-bold text-center"
					>
						Ready to get <br />
						<span className="text-black">{`what you're owed?`}</span>
					</Typography>
					<Button
						decoration="primary"
						size="large"
						className="mt-6 md:mt-8 !w-full md:!w-[197px] !h-12 md:!h-16 mx-auto"
						onClick={() => {
							customEvent({
								action: 'explore_all_cases_click',
								category: 'landing',
								label: 'Explore All Cases',
								value: 'Explore All Cases',
								callback: async () => {
									router.push(AppRoutes.LANDING_CASES);
								},
							});
						}}
					>
						Explore Cases
					</Button>
					{/* <Typography type="semibold-16" className="text-primary text-center">
						First, show me how it works
					</Typography> */}
				</div>
			</div>
		</div>
	);
};
